<template>
    <component
        :is="tag"
        v-bind="$attrs"
        class="z-link"
        :class="classObject"
        :download="downloadFile ? downloadTitle : null"
        :href="tag === 'a' ? href : false"
    >
        <z-icon
            v-if="iconName && position === 'left'"
            class="z-link__icon"
            :name="iconName"
            :dir="dir"
        /><span class="z-link__text"><slot/></span><z-icon
            v-if="iconName && position === 'right'"
            class="z-link__icon"
            :name="iconName"
            :dir="dir"
        />
    </component>
</template>

<script setup>
import {computed} from 'vue'

const props = defineProps({
    href: String,
    tag: {
        type: String,
        default: 'a',
    },
    size: {
        type: String,
        default: 's',
        validator: prop => ['xs', 's', 'm', 'l', 'xl'].includes(prop)
    },
    theme: {
        type: String,
        validator: prop => ['dark', 'light', 'boldline', 'bubble', 'bubble-rounded', 'white'].includes(prop)
    },
    borderType: {
        type: String,
        default: 'solid',
        validator: prop => ['solid', 'dashed'].includes(prop)
    },
    internal: Boolean,
    external: Boolean,
    sectionLink: Boolean,
    icon: String,
    iconPosition: {
        type: String,
        validator: prop => ['left', 'right'].includes(prop),
        default: 'left'
    },
    underlined: {
        type: Boolean,
        default: true
    },
    active: {
        type: Boolean,
        default: false
    },
    downloadFile: Boolean,
    downloadTitle: {
        type: String,
        default: ''
    },
    inlineFlex: {
        type: Boolean,
        default: false
    },
    dir: {
        type: String,
        validator: prop => ['left', 'right', 'down', 'up'].includes(prop),
    },
    originalIcon: {
        type: Boolean,
        default: false,
    }
})

const iconName = computed(() => {
    let icon = props.icon
    if (props.external) icon = 'link/external'
    if (props.internal) icon = 'link/internal'
    if (props.sectionLink) icon = 'project/leaf_s'

    return icon
})

const position = computed(() => {
    // let position = props.iconPosition
    // if (props.external) position = 'right'

    return props.iconPosition
})

const classObject = computed(() => {
    return ({
        'z-link--external': props.external,
        'z-link--internal': props.internal,
        'z-link--section-link': props.sectionLink,
        'z-link--underlined': props.underlined,
        'z-link--left-icon': iconName.value && position.value === 'left',
        'z-link--right-icon': iconName.value && position.value === 'right',
        'z-link--inline-flex': props.inlineFlex,
        [`z-link--border-${props.borderType}`]: props.borderType,
        [`z-link--theme-${props.theme}`]: props.theme,
        [`text-size-${props.size}`]: props.size,
        'is-active': props.active,
        'z-link--original-icon': props.originalIcon || props.sectionLink
    })
})

defineExpose({
    props
})
</script>

<style lang="scss" src="./index.scss"></style>
